import { render, staticRenderFns } from "./wxalink.vue?vue&type=template&id=66ae827e&scoped=true&"
import script from "./wxalink.vue?vue&type=script&lang=js&"
export * from "./wxalink.vue?vue&type=script&lang=js&"
import style0 from "./wxalink.vue?vue&type=style&index=0&id=66ae827e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ae827e",
  null
  
)

export default component.exports